var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHarnessIconinline = function SvgHarnessIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EE2B6C",
    strokeWidth: 3,
    d: "M5.5 5.5h61v61h-61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B4BEE",
    d: "M3.5 3.5h65v65h-65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2B4BEE",
    strokeWidth: 2,
    d: "M1 1h9v9H1zM62 1h9v9h-9zM1 62h9v9H1zM62 62h9v9h-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m51.299 29.786-9.07-9.08a10.3 10.3 0 0 0-3.75-2.268c-3.1-1.032-6.183-.226-8.68 2.267l-9.092 9.081a10.3 10.3 0 0 0-2.267 3.752c-1.035 3.098-.23 6.182 2.267 8.676l9.08 9.08a10.3 10.3 0 0 0 3.748 2.268 8.3 8.3 0 0 0 2.628.438c2.178 0 4.263-.92 6.052-2.705l9.076-9.08a10.3 10.3 0 0 0 2.271-3.753c1.032-3.098.227-6.179-2.27-8.676zM36.7 23.34c.685.22 1.318.582 1.855 1.061l2.683 2.687-5.232 5.229-5.232-5.233 2.697-2.701c.724-.72 1.744-1.485 3.236-1.047zM23.349 35.297a5.1 5.1 0 0 1 1.065-1.856l2.683-2.683 5.232 5.233-5.236 5.232-2.697-2.701c-.724-.72-1.484-1.74-1.05-3.233zm11.956 13.352a5.1 5.1 0 0 1-1.855-1.062l-2.675-2.653 5.232-5.236 5.232 5.232-2.698 2.702c-.723.72-1.74 1.484-3.236 1.047zm13.359-11.93a5.2 5.2 0 0 1-1.061 1.855l-2.683 2.65-5.232-5.233 5.232-5.233 2.698 2.698c.723.72 1.484 1.74 1.05 3.232"
  })));
};
export default SvgHarnessIconinline;